import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IHandleGet {
  currentPage?: number;
  itensPerPage?: number;
  nameSearch?: string;

  codeOperadora?: string;
  isActive?: "TRUE" | "FALSE" | "ALL";
}

export const useHttpTableComissaoCorretora = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const {
    setQtd_registros,
    setLoadingTable,
    itensPerPage,
    currentPage,
    nameSearch,
  } = useConfigPageContext();

  const { setListComissaoCorretora } = useContextComissoes();

  const handleGet = async (body: IHandleGet) => {
    setLoadingTable(true);

    api
      .post("/comissoes/GetCorretoras", {
        ...body,
        page: currentPage,
        limit: itensPerPage,
        filter: nameSearch,
      })
      .then((res) => {
        setListComissaoCorretora(res.data.rows);
        setQtd_registros(res.data.rowCount);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
